"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Unvisible = _interopRequireDefault(require("@rsuite/icon-font/lib/status/Unvisible"));

// Generated by script, don't edit it please.
var Unvisible = (0, _createSvgIcon["default"])({
  as: _Unvisible["default"],
  ariaLabel: 'unvisible',
  category: 'status',
  displayName: 'Unvisible'
});
var _default = Unvisible;
exports["default"] = _default;
module.exports = exports.default;